
export enum AnalyticsOutcome {
  SUCCESS = 'Success',
  ERROR = 'Error',
  EXCEPTION = 'Exception',
}
